import "ol/ol.css";
import { Map, View } from "ol";
import * as olProj from 'ol/proj';
import Projection from 'ol/proj/Projection.js';
import { unByKey } from "ol/Observable";
import TileLayer from "ol/layer/Tile";
import VectorTileLayer from 'ol/layer/VectorTile';
// import { Heatmap as HeatmapLayer } from "ol/layer";
import VectorTileSource from "ol/source/VectorTile";
import ImageLayer from "ol/layer/Image.js";
import ImageArcGISRest from "ol/source/ImageArcGISRest.js";
import TileArcGISRest from "ol/source/TileArcGISRest.js";
import VectorLayer from "ol/layer/Vector";
import Cluster from "ol/source/Cluster";
import TileWMS from "ol/source/TileWMS.js";
import XYZ from "ol/source/XYZ.js";
import { Vector as VectorSource } from "ol/source";
import TileGrid from "ol/tilegrid/TileGrid.js";
import Point from "ol/geom/Point.js";
import Polygon from "ol/geom/Polygon.js";
import Feature from "ol/Feature";
import LineString from "ol/geom/LineString.js";
import { ScaleLine, defaults as defaultControls } from "ol/control";
import { Fill, Stroke, Style, Icon, Text, Circle } from "ol/style";
import { GeoJSON, MVT } from "ol/format";
import EsriJSON from "ol/format/EsriJSON.js";
import { transform } from "ol/proj";

import DrawOverlays from "./widgets/DrawOverlays/cesium/DrawOverlays";
import { IOverlayParameter, IResult, ICenterLevel, ILayerConfig, IOverlayDelete, IOverlayClusterParameter, IFindParameter, IHeatParameter, IDrawOverlays, ShowPartParameter, ShowPartCancelParameter } from "@/types/map";
import { ClusterOpenlayers } from "./widgets/Cluster/openlayers/ClusterOpenlayers"; //聚合
import { FindFeatureOpenlayers } from "./widgets/FindFeature/openlayers/FindFeatureOpenlayers"; //查找定位
import { HeatMapOpenlayers } from "./widgets/HeatMap/openlayers/HeatMapOpenlayers"; //热力图
import { DrawOverlaysOpenlayers } from "./widgets/DrawOverlays/openlayers/DrawOverlaysOpenlayers"; //绘制-画线、画线、画多边形
import { ShowPartOpenlayers } from "./widgets/DrawOverlays/openlayers/ShowPartOpenlayers"; // 图层展示部分
import VectorTile from "ol/layer/VectorTile";
import { Coordinate } from "ol/coordinate";
// import Drive from "./Drive/Drive";
// import Model from "./Model/Model";
// import RouteDrive from "./Drive/RouteDrive";

export default class MapApp {
    private viewer!: any;
    private markLayer!: any;
    // private map!: any;
    private map!: Map;
    private view!: any;
    private mapConfig!: any;
    // private mapLoadListen!: any;
    private currentFeature = null;
    private areaPolygonLayer!: any;
    private _mouseOverEntity: any; //鼠标当前盖住的最上层的entity
    public mapLoaded!: () => void;
    public mapZoom!: (zoom: { new: number; old: number }) => void;
    public mapClick!: (event: any) => void;
    public showGisDeviceInfo!: (type: string, id: string, detail: any, label?: string) => void;
    public markerMouseMove!: (event: any) => void;
    public markerMouseIn!: (event: any) => void;
    public markerMouseOut!: (event: any) => void;

    public mouseGisDeviceInfo!: (event: any, type: string, id: string, detail: any) => void;
    /**
     * 地图初始化
     * 加载依赖文件，解析配置参数，初始化viewer对象
     */
    public async init(elementId: string, mapConfig: any): Promise<any> {
        //elementId:地图容器div ID, mapConfig:地图配置参数
        console.log(elementId, mapConfig, "数据");
        this.mapConfig = mapConfig;
        let tileLayer = new TileLayer({
            source: new TileWMS({
                url: mapConfig.baseLayer[0].url,
                params: mapConfig.baseLayer[0].params,
                tileGrid: new TileGrid({
                    resolutions: mapConfig.options.resolutions,
                    extent: mapConfig.options.origin,
                }),
            }),
        });
        tileLayer.set("layerID", "tileLayer_01");
        tileLayer.set("label", "baseLayer"); //设置图层唯一标识
        // 创建地图容器
        this.view = new View({
            projection: "EPSG:4326",
            center: mapConfig.options.center,
            zoom: mapConfig.options.level,
            maxZoom: 18,
            minZoom: 9,
            constrainResolution: true, // 设置缩放级别为整数
            smoothResolutionConstraint: false, // 关闭无级缩放地图
        });
        // 创建地图实例
        this.map = new Map({
            target: elementId,
            layers: [tileLayer],
            view: this.view,
            controls: defaultControls({
                zoom: false,
                rotate: false,
                attribution: false,
            }),
        });
        // 地图属性-配置文件
        (this.map as any).set("mapConfig", mapConfig);
        // 监听地图加载，创建图层
        // this.mapLoadListen = this.map.on("postrender", this.createLayer(mapConfig.customLayers, this.map));

        // 设置点位图层
        this.markLayer = new VectorLayer({
            source: new VectorSource(),
            style: () => {},
        });
        this.markLayer.set("markLayer", this.markLayer);
        this.map.addLayer(this.markLayer);
        this.markLayer.setZIndex(9);
        /**地图加载渲染完成**/
        this.map.once("postrender", (event: any) => {
            this.mapLoaded();
            this.createLayer(mapConfig.customLayers, this.map); // 监听地图加载，创建图层
        });
        this.map.getView().on("change:resolution", () => {
            const zoom = this.map.getView().getZoom()?.toFixed(0) || 0;
            this.mapZoom({ new: +zoom, old: +zoom });
        });

        this.map.on("pointermove", (event: any) => {
            var feature = this.map.forEachFeatureAtPixel(event.pixel, (feature: any) => {
                return feature;
            });
            if (feature) {
                this.currentFeature = feature;
                const coordinates = feature.getGeometry().getCoordinates();
                event.type = "mouseover";
                if (feature !== this.currentFeature) {
                    //移动到同一个
                    this.mouseGisDeviceInfo(event, feature.values_.markType, feature.values_.markId, feature.values_);
                } else {
                    //移动到了下一个
                    this.mouseGisDeviceInfo(event, feature.values_.markType, feature.values_.markId, feature.values_);
                }
                // console.log(11111);

                // feature.setStyle(
                //     new Style({
                //         image: new Circle({
                //             radius: 10,
                //             fill: new Fill({ color: "yellow" }),
                //             stroke: new Stroke({ color: "red", width: 2 }),
                //         }),
                //     })
                // );
            }
        });

        //监听缩放、移动事件
        this.map.on("moveend", (e: any) => {
            // console.log(e, 112);
            // let zoom = this.map.getView().getZoom(); //获取当前地图的缩放级别
            // this.zoom = zoom;
            // // console.log("zoom----", zoom);
            // const size = this.map.getSize();
            // const extent = this.map.getView().calculateExtent(size); //地图视口范围，左上角 右下角
            // this.extent = extent;
            // //const center = extent.getCenter(getExtent())
            // // console.log("地图视口范围===", extent);
            // this.$store.dispatch("function/zoom", zoom);
            // this.$emit("zoom", zoom);
        });
        this.map.on("singleclick", (event: any) => {
            // console.log(event.coordinate[0] + "," + event.coordinate[1]); //坐标
            var feature = this.map.forEachFeatureAtPixel(event.pixel, (feature: any) => {
                return feature;
            });
            if (feature) {
                let obj = feature.getProperties();
                // console.log(obj, "点位点击");
                let { markType, markId } = obj;
                this.showGisDeviceInfo(markType, markId, obj);
            } else {
                // console.log(event, "地图点击"); //坐标
                this.mapClick(event);
            }
        });
        //return resolve
        return new Promise<void>(resolve => {
            resolve();
        });
    }
    // 切换地图底图
    public changeBaseLayer(params: { LAYERS: string }): IResult {
        this.map.getAllLayers().find(layer =>{
            if (layer.get("label") == "baseLayer"){     
                this.map.removeLayer(layer);
            }
        });
        this.mapConfig.baseLayer.find((item: any) =>{
            if (item.params.LAYERS == params.LAYERS){
                console.log(item);
                let layer = new TileLayer({
                    source: new TileWMS({
                        url: item.url,
                        params: item.params,
                        tileGrid: new TileGrid({
                            resolutions: item.resolutions,
                            extent: item.origin,
                        }),
                    }),
                });
                layer.set("label", "baseLayer"); //设置图层唯一标识
                layer.setZIndex(-1);
                this.map.addLayer(layer);
            }
        });
        return {
            status: 0,
            message: `changeBaseLayer success`,
        };
    }
    // 创建图层
    public createLayer(customLayers: any, map: any) {
        // console.log(customLayers);
        customLayers.forEach((item: any) => {
            // console.log(item);
            let layer: any;
            switch (item.type) {
                case "feature": //ArcGIS-动态服务
                    console.log("创建动态图层：");
                    layer = new TileLayer({
                        // id: item.lebel,
                        source: new TileArcGISRest({
                            url: item.url,
                            params: item.params,
                        }),
                        visible: item.visible,
                        minZoom: item.minZoom,
                    });
                    layer.set("label", item.label); //设置图层唯一标识
                    break;
                case "feature2": //ArcGIS-动态服务-指定显示图层
                    console.log("创建动态图层2");
                    layer = new ImageLayer({
                        // id: item.lebel,
                        source: new ImageArcGISRest({
                            url: item.url,
                            params: item.params,
                        }),
                        visible: item.visible,
                        minZoom: item.minZoom,
                    });
                    layer.set("label", item.label); //设置图层唯一标识
                    break;
                case "feature3": //ArcGIS-动态服务-指定显示图层
                    console.log("创建动态图层3");
                    layer = new VectorTile({
                        source: new VectorTileSource({
                            url: "http://128.64.151.195:6080/arcgis/rest/services/Edpass/shanghai_base_area/MapServer", // 0是图层的索引，根据实际情况调整
                            format: new EsriJSON(),
                        }),
                    });
                    layer.set("label", item.label); //设置图层唯一标识
                    break;
                // case "feature3": //ArcGIS-动态服务-指定显示图层
                //     console.log("创建动态图层3");
                //     layer =  new VectorLayer({
                //         source: new VectorSource({
                //         //   url: "http://128.64.151.195:6080/arcgis/rest/services/Edpass/shanghai_base_area/MapServer/0", // 0是图层的索引，根据实际情况调整
                //           url: "http://128.64.151.195:6080/arcgis/rest/services/Edpass/shanghai_base_area/MapServer/0", // 0是图层的索引，根据实际情况调整
                //         //   format: new GeoJSON(),
                //         }),
                //         style: new Style({
                //           fill: new Fill({
                //             color: 'rgba(255, 255, 255, 0.6)',
                //           }),
                //           stroke: new Stroke({
                //             color: '#319FD3',
                //             width: 1,
                //           }),
                //         }),
                //       });
                //     layer.set("label", item.label); //设置图层唯一标识
                //     break;
                case "tiled": //ArcGIS-切片服务
                    // console.log("创建切片图层：");
                    let tileGrid = new TileGrid({
                        tileSize: 256,
                        origin: item.params.origin,
                        extent: item.params.extent,
                        resolutions: item.params.resolutions,
                    });
                    let pos = new Projection({
                        code: "EPSG:4326",
                    });
                    let source = new XYZ({
                        tileGrid: tileGrid,
                        projection: pos, //空间参考
                        url: item.url + "/tile/{z}/{y}/{x}",
                    });
                    layer = new TileLayer({
                        source: source,
                        visible: item.visible,
                        minZoom: item.minZoom,
                    });
                    layer.set("label", item.label); //设置图层唯一标识
                    break;
            }
            map.addLayer(layer);
        });
        // unByKey(this.mapLoadListen);
    }

    // 展示图层-已在初始化时加载图层，但并未显示
    public async showLayer(params: ILayerConfig) {
        console.log("展示图层");
        let toggleOther = params.toggleOther === true;
        let labels: string[] = params.label ? (params.label instanceof Array ? (params.label as string[]) || [] : [params.label]) : [];
        if (labels.length == 0) {
            return;
        }
        console.log(labels);
        this.map
            .getLayers()
            .getArray()
            .forEach((item: any) => {
                // console.log(item.get("label"));
                if (labels.indexOf(item.get("label")) > -1) {
                    if (!item.visible) {
                        console.log("展示图层：");
                        console.log(item);
                        item.setVisible(true);
                    }
                }
            });
    }
    // 隐藏图层
    public async hideLayer(params: ILayerConfig) {
        console.log("隐藏图层");
        console.log(params);
        let toggleOther = params.toggleOther === true;
        let labels: string[] = params.label ? (params.label instanceof Array ? (params.label as string[]) || [] : [params.label]) : [];
        if (labels.length == 0) {
            return;
        }
        this.map
            .getLayers()
            .getArray()
            .forEach((item: any) => {
                if (labels.indexOf(item.get("label")) > -1) {
                    if (!item.visible) {
                        console.log("展示图层：");
                        console.log(item);
                        item.setVisible(false);
                    }
                }
            });
    }
    // 点位聚合
    public async addOverlaysCluster(params: IOverlayClusterParameter): Promise<IResult> {
        console.log("点位聚合");
        console.log(params);
        const cluster = ClusterOpenlayers.getInstance(this.map);
        return await cluster.addOverlaysCluster(params);
    }
    // 去除点位聚合
    public async deleteOverlaysCluster(params: IOverlayDelete) {
        const cluster = ClusterOpenlayers.getInstance(this.map);
        return await cluster.deleteOverlaysCluster(params);
    }
    // 查找定位
    public async findFeature(params: IFindParameter): Promise<IResult> {
        const findfeature = FindFeatureOpenlayers.getInstance(this.map);
        return await findfeature.findLayerFeature(params);
    }
    // 热力图
    public async addHeatMap(params: IHeatParameter): Promise<IResult> {
        // return { message: "", status: 0, result: {} };
        const heatmap = HeatMapOpenlayers.getInstance(this.map);
        return await heatmap.addHeatMap(params);
    }
    // 画点、画线、画多边形
    public async startDrawOverlays(params: IDrawOverlays): Promise<void> {
        const drawoverlay = DrawOverlaysOpenlayers.getInstance(this.map);
        return await drawoverlay.startDrawOverlays(params);
    }
    // 停止绘制
    public async stopDrawOverlays(): Promise<void> {
        const drawoverlay = DrawOverlaysOpenlayers.getInstance(this.map);
        return await drawoverlay.stopDrawOverlays();
    }
    // 获取绘制结果、获取地图上所有绘制的覆盖物结果
    public async getDrawOverlays(): Promise<IResult> {
        const drawoverlay = DrawOverlaysOpenlayers.getInstance(this.map);
        return await drawoverlay.getDrawOverlays();
        // return { message: "", status: 0, result: {} };
    }
    // 删除绘制结果
    public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {
        const drawoverlay = DrawOverlaysOpenlayers.getInstance(this.map);
        return await drawoverlay.deleteDrawOverlays(params);
    }
    // 图层展示部分
    public async showPart(params: ShowPartParameter): Promise<void> {
        const drawoverlay = ShowPartOpenlayers.getInstance(this.map);
        return await drawoverlay.showPart(params);
    }
    // 取消图层展示部分
    public async showPartCancel(params: ShowPartCancelParameter): Promise<void> {
        const drawoverlay = ShowPartOpenlayers.getInstance(this.map);
        return await drawoverlay.showPartCancel(params);
    }
    // 置顶图层
    public moveLayerToTop(params: { type: string }): IResult {
        console.log(this.map.getAllLayers());
        if (params.type) {
            this.map.getAllLayers().find((layer: any) => {
                if (layer.get("label") == params.type){
                    layer.setZIndex(this.map.getAllLayers().length);
                };
            });
        };
        return {
            status: 0,
            message: `move success`,
        };
    }
    // 调整图层顺序
    public reorderLayer(params: { type: string; order: number }): IResult {
        if (params.type) {
            const findlayer = this.map.getAllLayers().find((layer: any) => {
                if (layer.get("label") == params.type){
                    layer.setZIndex(params.order);
                };
            });
        };
        return {
            status: 0,
            message: `reorder success`,
        };
    }

    //@todo 获取底图的最小缩放图层

    //-----------------------------对外接口实现----------------------------//

    /**
     * setMapCenterAndLevel
     * 设置地图视角中心点和层级
     */
    public setMapCenterAndLevel(params: ICenterLevel) {
        const x = (params as any).x;
        const y = (params as any).y;
        const level = params.level || 2;
        const duration = (params as any).duration || 2;
        this.map.getView().animate({
            center: [x, y],
            zoom: level, // 缩放级别
            rotation: undefined, // 缩放完成view视图旋转弧度
            duration: duration, // 缩放持续时间，默认不需要设置
        });
    }

    /**
     * addOverlays
     * 地图点位撒点
     */

    public async addOverlays(params: IOverlayParameter): Promise<IResult> {
        console.log(params, "数据");
        let coordinates: any = params.overlays || [];
        console.log(coordinates);
        let featureArr: any = [];
        let featureType: any = undefined;
        for (let i = 0; i < coordinates.length; i++) {
            let feature = await this.createdSymbol(coordinates[i], params);
            featureType = coordinates[i].symbol.type;
            featureArr.push(feature);
            feature?.setProperties({ fields: coordinates[i].fields, markType: params.type, markId: coordinates[i].id });
        }
        if (featureType == "simple-fill") {
            this.areaPolygonLayer = new VectorLayer({
                source: new VectorSource({
                    features: featureArr,
                }),
            });
            this.map.addLayer(this.areaPolygonLayer);
        } else {
            this.markLayer.set("label", params.type); //设置图层唯一标识
            this.markLayer.getSource().addFeatures(featureArr);
        }
        return { message: "", status: 0, result: {} };
    }
    /**
     * createdSymbol
     * 创建点位信息
     */

    private async createdSymbol(symbol: any, params: any): Promise<Feature | undefined> {
        let feature: any;
        if (symbol.symbol.type == "point" || symbol.symbol.type == "point-2d") {
            feature = new Feature({
                geometry: new Point([symbol.geometry.x, symbol.geometry.y]),
            });
            feature.setStyle(
                new Style({
                    image: new Icon({
                        src: symbol.symbol && symbol.symbol.url ? symbol.symbol.url : (params as any).defaultSymbol.url,
                        offset: symbol.symbol && symbol.symbol.offset ? symbol.symbol.offset : [0, 0],
                        scale: (symbol.symbol && symbol.symbol.scale) || 0.5,
                        opacity: (symbol.symbol && symbol.symbol.opacity) || 1,
                    }),
                    text: new Text(),
                })
            );
            if (params.custom && params.custom.visible) {
                //显示点名称，不显示点图标
                let textObj = new Text({
                    font: "16px sans-serif",
                    text: symbol.fields.deptName,
                    fill: new Fill({
                        color: [255, 255, 255, 1],
                    }),
                    // backgroundFill: new Fill({
                    //     color: [168, 50, 153, 0.6],
                    // }),
                    // padding: [2, 2, 2, 2],
                });
                feature.getStyle().setText(textObj);
                feature.getStyle().setImage();
            }
            feature.setProperties({ fields: symbol.fields, markType: params.type, markId: symbol.id, symbol: symbol.symbol });
            if (params.custom && params.custom.visible) {
                //显示点名称，不显示点图标
                let textObj = new Text({
                    font: params.custom.font,
                    text: symbol.fields.deptName,
                    fill: new Fill({
                        color: params.custom.color,
                    }),
                    // backgroundFill: new Fill({
                    //     color: [168, 50, 153, 0.6],
                    // }),
                    // padding: [2, 2, 2, 2],
                });
                feature.getStyle().setText(textObj);
                feature.getStyle().setImage();
            }
            feature.setProperties({ fields: symbol.fields, markType: params.type, markId: symbol.id, symbol: symbol.symbol });
        } else if (symbol.symbol.type == "line") {
            let paths = await this.setPaths(symbol);
            feature = new Feature({
                type: "LineString",
                geometry: new LineString(paths),
            });
            feature.setStyle(
                new Style({
                    stroke: new Stroke({
                        color: symbol.symbol.color,
                        width: symbol.symbol.width,
                    }),
                })
            );
        } else if (symbol.symbol.type == "polyline") {
            feature = new Feature({
                type: "LineString",
                geometry: new LineString(symbol.geometry.paths[0]),
            });
            feature.setStyle(
                new Style({
                    stroke: new Stroke({
                        color: symbol.symbol.color,
                        width: symbol.symbol.width,
                    }),
                })
            );
        } else if ((symbol.symbol.type = "simple-fill")) {
            feature = new Feature({
                name: symbol.name,
                type: "polygon",
                // geometry: new Polygon(symbol.geometry.rings, symbol.geometry.spatialReference),
                geometry: new Polygon(symbol.geometry.rings),
                // geometry: new Polygon(ringsArrAll, symbol.geometry.spatialReference),
                // geometry: new Polygon(await this.setPoint(symbol)),
            });
            feature.setStyle(
                new Style({
                    stroke: new Stroke({
                        width: symbol.symbol.outline.width,
                        color: await this.colorStringToRgbaArray(symbol.symbol.outline.color),
                    }),
                    fill: new Fill({
                        color: await this.colorStringToRgbaArray(symbol.symbol.outline.color),
                    }),
                })
            );
        }
        return feature;
    }
    // public async setPoint(symbol:any){
    //     let ringsArr:any = [];
    //     let ringsArrAll = [];
    //     symbol.geometry.rings.forEach(async(e: any) =>{
    //         // console.log(e);
    //         e.forEach(async (ee: Coordinate) =>{
    //             // console.log(transform(ee, 'EPSG:3857', 'EPSG:4326'));
    //             let lonLat =await transform(ee, 'EPSG:3857', 'EPSG:4326');
    //             ringsArr.push(lonLat);
    //         });
    //     });
    //     ringsArrAll.push(ringsArr);
    //    return ringsArrAll
    // }
    public async setPaths(symbol: any) {
        let paths: any = [];
        if (symbol.geometry.paths.length == 1) {
            if (symbol.geometry.paths[0].length == 1) {
                if (symbol.geometry.paths[0][0].length == 1) {
                } else {
                    paths = symbol.geometry.paths[0][0];
                }
            } else {
                paths = symbol.geometry.paths[0];
            }
        } else {
            paths = symbol.geometry.paths;
        }
        return paths;
    }
    public async colorStringToRgbaArray(colorStr: any) {
        const colorArray = `rgba(${colorStr})`;
        return colorArray;
    }

    //   // 使用示例
    //   const colorStr = 'rgba(255, 0, 0, 0.5)';
    //   const rgbaArray = colorStringToRgbaArray(colorStr);
    //   console.log(rgbaArray); // 输出: [255, 0, 0, 0.5]
    /**
     * deleteOverlays
     * 地图点位删除
     */

    public async deleteOverlays(params: IOverlayDelete): Promise<IResult> {
        let ids = params.ids || [];
        let types = params.types || [];
        let id = params.id || "";

        let arrObj: any = this.map
            .getLayers()
            .getArray()
            .find((item: any) => item.get("markLayer"));
        let source = arrObj.get("markLayer").getSource();

        source.forEachFeature((f: any) => {
            let { markType, markId } = f.getProperties();
            if (ids.indexOf(markId) > -1) {
                source.removeFeature(f);
            }
            if (types.indexOf(markType) > -1) {
                source.removeFeature(f);
            }
            if (id == markId) {
                source.removeFeature(f);
            }
        });
        return { message: "", status: 0, result: {} };
    }

    /**
     * deleteAllOverlays
     * 删除地图所有点位
     */
    public async deleteAllOverlays() {
        let arrObj: any = this.map
            .getLayers()
            .getArray()
            .find((item: any) => item.get("markLayer"));
        console.log(arrObj, "数据");
        let source = arrObj.get("markLayer").getSource();
        source.forEachFeature((f: any) => {
            source.removeFeature(f);
        });
    }
}
